export default __webpack_public_path__ + "static/media/javascript-programming-language-icon.43e744a2.svg";